<template>
  <div class="content">
    <div class="content_title">
      Списания
    </div>
    <div class="content_row" v-for="(writeoff, key) in writeoffs" :key="key">
      <div>
        Дата:
        {{ writeoff.DATE }}
      </div>
      <div>
        Сумма:
        {{ writeoff.SUM }}
      </div>
      <div>
        Пени:
        {{ writeoff.PENALTY_SUM }}
      </div>
      <div>
        Оплаченная сумма:
        {{ writeoff.PAYMENT_SUM }}
      </div>
      <div>
        <label>Сумма оплаты: <input v-model="writeoff.NEW_PAYMENT"/></label>
      </div>
      <div>
        <button @click="payWriteoffs(writeoff)">Оплатить аккаунт</button>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "GetPaymentsList",
  props: {
    updateList: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      url: config.backend_url,
      detailUrl: "",
      writeoffs: [],
      showLink: true,
      login: "",
      password: "",
      server_ip: ""
    };
  },
  computed: {},
  watch: {
    updateList: function(state) {
      if (state) {
        this.getParsecAccounts();
      }
    }
  },
  methods: {
    getWriteoffs: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "writeoffs/get-list/",
          //filter: {AGREEMENT: user.id},
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.writeoffs = data;
          }
        });
    },
    payWriteoffs: function(writeoff) {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "writeoffs/pay-writeoff/",
          data: writeoff,
          method: "POST"
        })
        .then(function(response) {
          self.getWriteoffs();
        });
    }
  },
  created() {
    this.getWriteoffs();
    this.detailUrl = this.$route.fullPath;
  }
};
</script>
